export const learnerAiAssistantsText = {
  hello: 'Hello! 👋',
  info: 'Select an assistant to get ideas, advice, or answers to your questions.',
  emptyState1: 'No assistants',
  emptyState2: 'have been assigned to you.',
};
